import { WSFilter } from "@wingspanhq/fe-component-library";
import { accountTypeToHumanReadable } from "../../../utils/accountTypeToHumanReadable";
import { STATEMENT_ACCOUNT_TYPES } from "./types";

export function buildStatementsFiltersConfig(): WSFilter[] {
  return [
    {
      title: "Account type",
      name: "accountType",
      type: "radio",
      options: STATEMENT_ACCOUNT_TYPES.map(accountType => ({
        name: accountType,
        label: accountTypeToHumanReadable(accountType)
      }))
    }
  ];
}
